var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, copyDefault, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && (copyDefault || key !== "default"))
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toESM = (module2, isNodeMode) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", !isNodeMode && module2 && module2.__esModule ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
var __toCommonJS = /* @__PURE__ */ ((cache) => {
  return (module2, temp) => {
    return cache && cache.get(module2) || (temp = __reExport(__markAsModule({}), module2, 1), cache && cache.set(module2, temp), temp);
  };
})(typeof WeakMap !== "undefined" ? /* @__PURE__ */ new WeakMap() : 0);

// src/index.tsx
var src_exports = {};
__export(src_exports, {
  Popover: () => import_react5.Popover,
  PopoverAnchor: () => import_react5.PopoverAnchor,
  PopoverArrow: () => import_react5.PopoverArrow,
  PopoverBody: () => import_react5.PopoverBody,
  PopoverCloseButton: () => import_react5.PopoverCloseButton,
  PopoverContent: () => import_react5.PopoverContent,
  PopoverFooter: () => import_react5.PopoverFooter,
  PopoverHeader: () => import_react5.PopoverHeader,
  PopoverTrigger: () => import_react5.PopoverTrigger,
  PopoverWizardBody: () => PopoverWizardBody,
  SimplePopover: () => SimplePopover,
  WizardPopover: () => WizardPopover
});
var import_react5 = require("@chakra-ui/react");

// src/PopoverWizardBody.tsx
var import_react = require("@chakra-ui/react");
var import_spor_button_react = require("@vygruppen/spor-button-react");
var import_spor_i18n_react = require("@vygruppen/spor-i18n-react");
var import_spor_icon_react = require("@vygruppen/spor-icon-react");
var import_spor_layout_react = require("@vygruppen/spor-layout-react");
var React = __toESM(require("react"));
var PopoverWizardBody = ({ children }) => {
  const [currentStep, setCurrentStep] = React.useState(1);
  const totalSteps = React.Children.count(children);
  const { isOpen } = (0, import_react.usePopoverContext)();
  React.useEffect(() => {
    if (!isOpen && currentStep > 1) {
      const id = setTimeout(() => setCurrentStep(1), 500);
      return () => clearTimeout(id);
    }
  }, [isOpen, currentStep]);
  return /* @__PURE__ */ React.createElement(import_react.PopoverBody, null, /* @__PURE__ */ React.createElement(import_spor_layout_react.Stack, {
    spacing: 1.5
  }, /* @__PURE__ */ React.createElement(import_spor_layout_react.Box, null, React.Children.toArray(children)[currentStep - 1]), /* @__PURE__ */ React.createElement(import_spor_layout_react.Flex, {
    gap: 3
  }, /* @__PURE__ */ React.createElement(StepIndicator, {
    totalSteps,
    currentStep
  }), /* @__PURE__ */ React.createElement(NextStepButton, {
    isLastStep: totalSteps === currentStep,
    onNext: () => setCurrentStep((prev) => prev + 1)
  }))));
};
var StepIndicator = ({ totalSteps, currentStep }) => {
  const steps = createRange(1, totalSteps);
  return /* @__PURE__ */ React.createElement(import_spor_layout_react.Flex, {
    gap: 1,
    alignItems: "center"
  }, steps.map((step) => /* @__PURE__ */ React.createElement(import_spor_layout_react.Box, {
    key: step,
    width: 1,
    height: 1,
    borderRadius: "50%",
    transition: "medium",
    transitionProperty: "background-color",
    backgroundColor: step === currentStep ? "alias.seaMist" : "alias.greenHaze"
  })));
};
var createRange = (start, end) => {
  return new Array(end - start + 1).fill(null).map((_, i) => i + start);
};
var NextStepButton = ({ isLastStep, onNext }) => {
  const { onClose } = (0, import_react.usePopoverContext)();
  const { t } = (0, import_spor_i18n_react.useTranslation)();
  return /* @__PURE__ */ React.createElement(import_spor_button_react.Button, {
    variant: "additional",
    size: "sm",
    color: "alias.white",
    leftIcon: isLastStep ? void 0 : /* @__PURE__ */ React.createElement(import_spor_icon_react.ArrowRightFill18Icon, null),
    onClick: isLastStep ? onClose : onNext
  }, t(isLastStep ? texts.finish : texts.nextStep));
};
var texts = {
  nextStep: {
    [import_spor_i18n_react.Language.NorwegianBokmal]: "Neste",
    [import_spor_i18n_react.Language.Swedish]: "N\xE4sta",
    [import_spor_i18n_react.Language.English]: "Next"
  },
  finish: {
    [import_spor_i18n_react.Language.NorwegianBokmal]: "Fullf\xF8r",
    [import_spor_i18n_react.Language.Swedish]: "Fullf\xF6r",
    [import_spor_i18n_react.Language.English]: "Finish"
  }
};

// src/SimplePopover.tsx
var import_react2 = require("@chakra-ui/react");
var import_react3 = __toESM(require("react"));
var SimplePopover = (_a) => {
  var _b = _a, {
    children,
    triggerElement,
    onClose,
    isOpen,
    defaultIsOpen,
    placement = "bottom",
    size = "sm",
    withCloseButton = false,
    borderRadius
  } = _b, props = __objRest(_b, [
    "children",
    "triggerElement",
    "onClose",
    "isOpen",
    "defaultIsOpen",
    "placement",
    "size",
    "withCloseButton",
    "borderRadius"
  ]);
  return /* @__PURE__ */ import_react3.default.createElement(import_react2.DarkMode, null, /* @__PURE__ */ import_react3.default.createElement(import_react2.Popover, __spreadValues({
    onClose,
    isOpen,
    defaultIsOpen,
    placement,
    size,
    arrowSize: 12,
    arrowShadowColor: "none"
  }, props), triggerElement && /* @__PURE__ */ import_react3.default.createElement(import_react2.PopoverTrigger, null, triggerElement), /* @__PURE__ */ import_react3.default.createElement(import_react2.PopoverContent, {
    borderRadius
  }, /* @__PURE__ */ import_react3.default.createElement(import_react2.PopoverArrow, null), withCloseButton && /* @__PURE__ */ import_react3.default.createElement(import_react2.PopoverCloseButton, null), /* @__PURE__ */ import_react3.default.createElement(import_react2.PopoverBody, null, children))));
};

// src/WizardPopover.tsx
var import_react4 = require("@chakra-ui/react");
var React3 = __toESM(require("react"));
var WizardPopover = ({
  children,
  triggerElement,
  withCloseButton = false
}) => {
  return /* @__PURE__ */ React3.createElement(import_react4.DarkMode, null, /* @__PURE__ */ React3.createElement(import_react4.Popover, {
    size: "lg"
  }, /* @__PURE__ */ React3.createElement(import_react4.PopoverTrigger, null, triggerElement), /* @__PURE__ */ React3.createElement(import_react4.PopoverContent, null, /* @__PURE__ */ React3.createElement(import_react4.PopoverArrow, null), withCloseButton && /* @__PURE__ */ React3.createElement(import_react4.PopoverCloseButton, null), /* @__PURE__ */ React3.createElement(PopoverWizardBody, null, children))));
};
module.exports = __toCommonJS(src_exports);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Popover,
  PopoverAnchor,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverFooter,
  PopoverHeader,
  PopoverTrigger,
  PopoverWizardBody,
  SimplePopover,
  WizardPopover
});
